const FAVOURITE_QUERY_KEY = 'favourite-only';

export default FAVOURITE_QUERY_KEY;
